import { COMMENT_HTML_ANCHOR_PREFIX } from 'models/daos/comment/constants'
import { ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER } from 'modules/routes/constants/index.cjs'
import { hasHashValueLocationUtil } from 'modules/router/utils'

function hasScrollToTopRouteUtil (location) {
  return !ROUTE_PATHS_WITHOUT_GYMAHOLIC_HEADER.some(
    pathWithoutGymaholicHeader => {
      return !location.pathname.indexOf(pathWithoutGymaholicHeader)
    }
  ) && !hasHashValueLocationUtil(location, COMMENT_HTML_ANCHOR_PREFIX)
}

export default hasScrollToTopRouteUtil
